import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
@Injectable()
export class AppInterceptor implements HttpInterceptor {
    constructor(
        private router: Router
    ) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available            

        if (request.url && request.url.indexOf("files/upload") !== -1) {
            request = request.clone({
                setHeaders: {
                    'Accept': '*/*',
                    'XApiKey': environment.XApiKey,
                    'TenantName': environment.TenantName,
                    'TenantId': environment.TenantId,
                    'consumer': 'WEB',
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "*",
                    "Access-Control-Allow-Headers": "*"
                }
            });
        } else {
            request = request.clone({
                setHeaders: {
                    'XApiKey': environment.XApiKey,
                    'TenantName': environment.TenantName,
                    'TenantId': environment.TenantId,
                    'consumer': 'WEB',
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "*",
                    "Access-Control-Allow-Headers": "*"
                }
            });
        }
        if (localStorage.getItem('currentSaraAppTokenUser')) {
            // add authorization header with jwt token if available
            let currentHRMSUser = JSON.parse(localStorage.getItem('currentSaraAppTokenUser')!.toString());
            if (currentHRMSUser && currentHRMSUser.token) {
                request = request.clone({
                    setHeaders: {
                        'Authorization': 'Bearer ' + currentHRMSUser.token,
                    }
                });
            }
        }
        return next.handle(request);
    }
}